import { SoundEngineList } from "../../context/juno/SoundContext";

interface ModelRequirements {
  prompt: boolean;
  audio1: boolean;
  lyric: boolean;
  negativePrompt: boolean;
}

// モデルごとの必須パラメータを定義
export const modelRequirements: Record<SoundEngineList, ModelRequirements> = {
  CASSETTEAI: {
    prompt: true,
    audio1: false,
    lyric: false,
    negativePrompt: false,
  },
  CASSETTEAI_SFX: {
    prompt: true,
    audio1: false,
    lyric: false,
    negativePrompt: false,
  },
  DIFFRHYTHM: {
    prompt: true,
    audio1: false,
    lyric: false,
    negativePrompt: false,
  },
  ELEVENLABS: {
    prompt: true,
    audio1: false,
    lyric: false,
    negativePrompt: false,
  },
  MINIMAX: {
    prompt: false, // プロンプトは必須ではない
    audio1: true, // Audio1は必須
    lyric: false,
    negativePrompt: false,
  },
  MMAUDIO: {
    prompt: true,
    audio1: false,
    lyric: false,
    negativePrompt: false,
  },
};

// バリデーション関数
export const validateSoundParams = (
  model: SoundEngineList,
  params: {
    prompt: string;
    audio1: string;
    lyric: string;
    negativePrompt: string;
  }
): { isValid: boolean; errorKey: string | null } => {
  const requirements = modelRequirements[model];

  // プロンプトのバリデーション
  if (requirements.prompt && !params.prompt) {
    return { isValid: false, errorKey: "juno.sound.error.required.prompt" };
  }

  // プロンプトの長さバリデーション
  if (params.prompt && params.prompt.length > 1000) {
    return { isValid: false, errorKey: "juno.sound.error.max.prompt" };
  }

  if (params.prompt && params.prompt.length > 450 && model === "ELEVENLABS") {
    return { isValid: false, errorKey: "juno.sound.error.max.prompt" };
  }

  // Audio1のバリデーション
  if (requirements.audio1 && !params.audio1) {
    return { isValid: false, errorKey: "juno.sound.error.required.audio" };
  }

  // 歌詞のバリデーション
  if (requirements.lyric && !params.lyric) {
    return { isValid: false, errorKey: "juno.sound.error.required.lyric" };
  }

  // ネガティブプロンプトのバリデーション
  if (requirements.negativePrompt && !params.negativePrompt) {
    return { isValid: false, errorKey: "juno.sound.error.required.negativePrompt" };
  }

  // すべてのバリデーションが通過した場合
  return { isValid: true, errorKey: null };
};
